module.exports = __webpack_public_path__ + "static/media/Group 9.2a973989.svg";